import http from './http'

export default {
    /**
     * Consulta los posters
     * @returns {Promise}
     */
    all() {
        return http.get('posters')
    },

    /**
     * Create a new poster
     * @param {Object} poster 
     * @returns {Promise}
     */
    create(poster) {
        const formData = new FormData()
        formData.append("nombre", poster.nombre)
        formData.append("descripcion", poster.descripcion)
        formData.append("imagen", poster.imagen)

        return http.post(`posters`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    /**
     * Get a poster
     * @param {String} poster 
     * @returns {Promise}
     */
    get(poster) {
        return http.get(`posters/${poster}`)
    },

    /**
     * Update a poster
     * @param {int} poster 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(poster, payload) {
        
        if (payload.imagen == null) {
            return http.put(`posters/${poster}`, payload)
        }

        const formData = new FormData()
        formData.append("descripcion", payload.descripcion)
        formData.append("imagen", payload.imagen)

        // Necesario para subir archivos por peticion PUT
        // En caso contrario no enviara nada en el cuerpo
        // O hacer una peticion POST
        formData.append("_method", 'PUT')

        return http.post(`posters/${poster}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    /**
     * Delete a poster
     * @param {int} poster 
     * @returns {Promise}
     */
    delete(poster) {
        return http.delete(`posters/${poster}`)
    },

    /**
     * Restore a poster
     * @param {int} poster 
     * @returns {Promise}
     */
    restore(poster) {
        return http.put(`posters/${poster}/restore`)
    },
}